module.exports = __webpack_public_path__ + "img/close-white.720209ec.svg";